const verifyEligibilityJob = 'verify eligibility';
const claimSearchJob = 'claim search';
const changeProvider = 'change care provider';
const changePayer = 'change payer';
const checkPriorAuthByCode = 'check prior authorizations by code';
const preferredLab = 'preferred lab';
const searchForMultipleMembers = 'search for multiple members';
const pageNamePrefix = 'uhcprovsec:';

const getPageData = (data) => {
  return {
    pageName: '',
    businessUnit: 'uhc',
    siteSectionL1: '',
    siteSectionL2: '',
    siteSectionL3: '',
    siteSectionL4: '',
    siteSectionL5: '',
    website: 'uhcprovider secure',
    referringSite: document.referrer,
    loginStatus: 'loggedin',
    corporateProviderName: data.corporateProviderName,
    payerName: data.payerName,
    payerNameId: `${data.payerName} - ${data.payerId}`,
    membertPatientType: '',
    claimStatus: '',
    claimNum: '',
    ticketNum: '',
    providerGeo: '', // NA
    providerDept: '', // NA
    providerTitle: '', // NA
    providerOrgType: '', // NA
    providerRoleDescription: '', // NA
    healthCareOrganization: data.healthCareOrganization || '',
    providerTaxId: data.taxIdNumber || '',
    providerAccountDesc: '', // NA
    providerUuid: data.uuid || '',
    providerMpin: data.corporateProviderMpin || '',
    language: '',
    platform: '',
    memberId: '',
    memberPatientType: '',
    memberGroupNumber: '',
    memberPolicyType: '',
    memberNetworkStatus: '',
    memberInsuranceType: '',
    uhgEmployee: '',
    adminProviderUuid: data?.adminProviderUuid ? data.adminProviderUuid : '',
    isEmulated: data.isTechnicalUser ? 'Emulated' : 'Not Emulated',
    careProviderMpin: data.careProviderMpin,
    careProviderFirstName: data.careProviderFirstName || '',
    careProviderLastName: data.careProviderLastName,
    allPermission: data.allPermission || false,
    permissionCode: data.permissionCode || [],
  };
};

const noPermissionsData = (data) => {
  const basePageData = { ...getPageData(data) };
  delete basePageData.allPermission;
  delete basePageData.permissionCode;

  return basePageData;
};

// this data in this function will make the adobe trigger await
const getRequiredData = (data) => {
  return {
    payerName: data.payerName,
    payerId: data.payerId,
    corporateProviderName: data.corporateProviderName,
    providerTaxId: data.taxIdNumber,
    uuid: data.uuid,
  };
};

const payerNameIdFormatter = (payerLabel) => {
  const payerNameId = payerLabel.split(' - ').reverse();
  const [payerName, payerId] = payerNameId;

  return {
    payerName,
    payerId,
    payerNameId: payerNameId.join(' - '),
  };
};

export const adobeTags = {
  LANDING_PAGE_LOAD: (data) => {
    return {
      event: 'pageload',
      requiredData: {
        ...getRequiredData(data),
      },
      data: {
        ...noPermissionsData(data),
        pageName: pageNamePrefix,
        accountNumber: data.accountNumber,
      },
    };
  },
  CONTACT_US_PAGE_LOAD: (data) => {
    return {
      event: 'pageload',
      requiredData: {
        ...getRequiredData(data),
      },
      data: {
        ...noPermissionsData(data),
        pageName: `${pageNamePrefix}${data.pageName}`,
        siteSectionL1: 'contact-us',
        accountNumber: data.accountNumber,
      },
    };
  },
  COVEO_APP_SEARCH: (data) => {
    const { coveoSearch } = data;
    return {
      event: 'jobUHCPPInternalSearchEvent',
      data: {
        ...coveoSearch,
      },
    };
  },
  COVEO_RESULT_LINK_CLICK: (data) => {
    const { coveoSearch } = data;
    return {
      event: 'jobUHCPPInternalSearchResultsClickEvent',
      data: {
        searchTerm: coveoSearch.searchTerm,
        searchPagination: coveoSearch.searchPagination,
        searchResults: coveoSearch.searchResults,
        searchSort: coveoSearch.searchSort,
        searchResultLink: data.searchResultLink,
        searchResultPosition: data.searchResultPosition,
      },
    };
  },
  COVEO_NOT_FINDING_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'UHCPP Enhanced Coveo Search',
        interactionValue:
          'Not finding what you are looking for? Try searching UHCProvider.com',
        interactionContext: data.interactionContext,
      },
    };
  },
  APP_SEARCH_PAGE_LOAD: (data) => {
    return {
      event: 'pageload',
      requiredData: {
        ...getRequiredData(data),
        optinStatus: data.optinStatus,
      },
      data: {
        ...noPermissionsData(data),
        pageName: `${pageNamePrefix}${data.pageName}`,
        siteSectionL1: 'Search results',
        optinStatus: data.optinStatus,
        accountNumber: data.accountNumber,
      },
    };
  },
  ADDITIONAL_TOOLS_PAGE_LOAD: (data) => {
    return {
      event: 'pageload',
      requiredData: {
        ...getRequiredData(data),
      },
      data: {
        ...noPermissionsData(data),
        pageName: `${pageNamePrefix}${data.pageName}`,
        siteSectionL1: 'Additional tools',
        accountNumber: data.accountNumber,
      },
    };
  },
  SET_LEGACY_LINK_AS_PRIMARY: (data) => {
    return {
      event: 'exit click',
      data: {
        exitLink: 'make legacy link primary view',
      },
    };
  },
  VERIFY_ELIGIBILITY_START: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: verifyEligibilityJob,
      },
    };
  },
  VERIFY_ELIGIBILITY_SUBMIT: (data) => {
    return {
      event: 'jobEligibilitySubmit',
      data: {
        jobName: verifyEligibilityJob,
        searchCriteria: data.searchCriteria,
        searchBy: data.searchBy,
        searchDateStart: data.searchDateStart,
        searchDateEnd: data.searchDateEnd,
        memberId: data.memberId,
      },
    };
  },

  VERIFY_ELIGIBILITY_COMPLETION: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: verifyEligibilityJob,
      },
    };
  },
  CLAIM_SEARCH_START: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: claimSearchJob,
      },
    };
  },
  CLAIM_SEARCH_SUBMIT: (data) => {
    return {
      event: 'jobClaimSearchSubmit',
      data: {
        jobName: claimSearchJob,
        searchCriteria: data.searchCriteria,
        searchBy: data.searchBy,
        searchDateStart: data.searchDateStart,
        searchDateEnd: data.searchDateEnd,
        memberId: data.memberId,
        claimNum: data.claimNumber,
        ticketNum: data.ticketNumber,
      },
    };
  },
  CLAIM_SEARCH_COMPLETION: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: claimSearchJob,
      },
    };
  },
  RETURN_TO_LINK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'return to legacy link',
      },
    };
  },
  CHANGE_CARE_PROVIDER_START: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: changeProvider,
        interactionName: 'interactionname jobstart link',
        interactionValue: 'interactionvalue link',
      },
    };
  },
  CHANGE_CARE_PROVIDER_COMPLETE: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: changeProvider,
        interactionName: 'interactionname jobComplete link',
        interactionValue: 'interactionvalue link',
      },
    };
  },
  CHANGE_CARE_PROVIDER_SAVE: (data) => {
    const { payerName, payerNameId } = payerNameIdFormatter(data.payerLabel);
    return {
      event: 'changeprovider',
      data: {
        providerMpin: data.corporateProviderMpin,
        corporateProviderName: data.corporateProviderName,
        providerTaxId: data.taxIdNumber,
        healthCareOrganization: data.healthCareOrganization,
        ipAddress: data.ipAddress,
        optinStatus: data.optinStatus,
        payerId: data.payerId,
        payerName,
        payerNameId,
        providerAccountDesc: '',
        providerDept: '',
        providerGeo: '',
        providerOrgType: '',
        providerRoleDescription: '',
        providerTitle: '',
        providerUuid: data.uuid,
        careProviderMpin: data.careProviderMpin,
      },
    };
  },
  CUSTOMIZE_HOMEPAGE_START_CLICK: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: 'customize homepage flyout',
      },
    };
  },
  CUSTOMIZE_HOMEPAGE_SAVE_AND_CLOSE_CLICK: (data) => {
    return {
      event: 'jobCustomizeHomepageFlyoutSubmit',
      data: {
        jobName: 'customize homepage flyout',
        maintoolsSelected: data.selectedMainTools,
        maintoolsDeSelected: data.deselectedMainTools,
        itemsSelected: data.selectedItems,
        itemsDeSelected: data.deselectedItems,
        itemsDefaultOrderChanged: data.itemsDefaultOrderChanged,
        mainToolsDefaultOrderChanged: data.mainToolsDefaultOrderChanged,
        providerUuid: data.providerUuid,
        providerTaxId: data.providerTaxId,
        providerMpin: data.providerMpin,
      },
    };
  },
  CUSTOMIZE_HOMEPAGE_COMPLETE: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: 'customize homepage flyout',
      },
    };
  },
  CUSTOMIZE_HOMEPAGE_MAIN_TOOL_SELECT_DESELECT: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.toolSelected
          ? 'home page customization flyout tool select'
          : 'home page customization tool de-select',
        interactionValue: data.toolName,
        interactionContext:
          'home page customization flyout - main tools section',
      },
    };
  },
  CUSTOMIZE_HOMEPAGE_ITEM_SELECT_DESELECT: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.itemSelected
          ? 'home page customization flyout item select'
          : 'home page customization flyout item de-select',
        interactionValue: data.itemName,
        interactionContext: 'home page customization flyout',
      },
    };
  },
  VIEW_RECENT_SEARCH_RESULTS: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'view recent search results',
      },
    };
  },
  VIEW_CLAIMS_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'smart edit cta click',
        interactionValue: 'view claims',
      },
    };
  },
  FIND_A_CLAIM: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'unitedhealthcare widget',
        interactionValue: 'find a claim',
      },
    };
  },
  PRINT_PAGE: (data) => {
    return {
      event: 'print',
    };
  },
  VIEW_ELIGIBILITY: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'view patients eligibility and benefits',
      },
    };
  },
  VIEW_ELIGIBILITY_MEMBER_NAME_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'view patients eligibility and benefits',
        interactionValue: 'member name',
      },
    };
  },
  CHANGE_PAYER: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: changePayer,
      },
    };
  },
  CHANGE_PAYER_COMPLETION: (data) => {
    const { payerName, payerNameId } = payerNameIdFormatter(data.payerLabel);
    return {
      event: 'jobCompleteChangePayer',
      data: {
        jobName: changePayer,
        payerName,
        payerNameId,
      },
    };
  },
  SEARCH_DIAGNOSIS_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'search diagnosis code',
        interactionValue: data.searchDiagnosisCode,
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  SELECT_DIAGNOSIS_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'select a diagnosis code',
        interactionValue: data.selectedDiagnosisCodes,
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  SEARCH_CPT_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'search cpt code',
        interactionValue: data.searchCptCode,
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  SELECT_CPT_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'select a cpt code',
        interactionValue: data.selectedCptCodes,
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  REMOVE_CPT_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'remove a cpt code',
        interactionValue: data.deletedCptCode,
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  REMOVE_DIAGNOSIS_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'remove a diagnosis code',
        interactionValue: data.deletedDiagnosisCode,
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  ADD_ANOTHER_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'add another code',
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  PERFORM_INQUIRY: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'perform inquiry',
        interactionValue: data.numberOfselectedCodes,
        interactionContext: checkPriorAuthByCode,
      },
    };
  },
  CHECK_PRIOR_AUTH_BY_CODE_COMPLETION: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: checkPriorAuthByCode,
      },
    };
  },
  DOWNLOAD_CLICK: (data) => {
    return {
      event: 'download click',
      data: {
        fileName: data.fileName,
        fileContext: data.fileType || '',
        fileURL: data.fileURL || '',
      },
    };
  },
  SHOW_PAYMENT_INFO: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'payment information widget',
        interactionValue: 'show details',
      },
    };
  },
  MODAL_OPEN: (data) => {
    return {
      event: 'modal view',
      data: {
        modalName: data.modalName,
      },
    };
  },
  MODAL_CLOSE: (data) => {
    return {
      event: 'modal close',
      data: {
        modalName: data.modalName,
      },
    };
  },
  OOPS_MODAL_LINK_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: data.interactionContext,
      },
    };
  },
  NAVIGATION_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'navigation',
        interactionValue: data.name,
      },
    };
  },
  PAGE_NAV_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'jump link',
        interactionValue: data.linkName,
        interactionContext: '',
      },
    };
  },
  MULTI_MEMBER_SEARCH_START: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: searchForMultipleMembers,
      },
    };
  },
  MULTI_MEMBER_SEARCH_SUBMIT: (data) => {
    return {
      event: 'jobSearchforMultipleMembersSubmit',
      data: {
        jobName: searchForMultipleMembers,
      },
    };
  },
  MULTI_MEMBER_SEARCH_COMPLETE: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: searchForMultipleMembers,
      },
    };
  },
  FIND_A_CODE_START: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: 'search by cpt/diagnostic codes',
      },
    };
  },
  FIND_A_CODE_SUBMIT: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'search diagnosis code',
        interactionValue: data.searchTerm,
        interactionContext: 'search by cpt/diagnostic codes',
      },
    };
  },

  APP_SEARCH: (data) => {
    return {
      event: 'jobUHCPPInternalSearchEvent',
      data: {
        searchTerm: data.searchTerm,
        searchPagination: 1,
        searchResults: data.resultCount,
        searchSort: data.sort,
        searchItemsPerPage: data.resultCount,
        searchStartIndex: 0,
        searchTermFlag: data.searchflag ? data.searchflag : 'NoValue',
      },
    };
  },

  APP_SEARCH_INTERNAL_LINK_NAVIGATE: (data) => {
    return {
      event: 'jobUHCPPInternalSearchResultsClickEvent',
      data: {
        searchTerm: data.searchTerm,
        searchPagination: 1,
        searchResults: data.resultCount,
        searchSort: data.sort,
        searchResultLink: data.name,
        searchResultPosition: data.index,
      },
    };
  },

  FIND_PROCEDURE_CODE_SUBMIT: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'search procedure code',
        interactionValue: data.searchTerm,
        interactionContext: 'search by cpt/diagnostic codes',
      },
    };
  },
  FIND_A_CODE_COMPLETE: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: 'search by cpt/diagnostic codes',
      },
    };
  },
  EXIT_LINK_NAVIGATE: (data) => {
    return {
      event: 'exit click',
      data: {
        exitLink: data.linkText,
        exitURL: data.linkUrl || '',
      },
    };
  },
  EXIT_LINK_NAVIGATE_YOUR_FEATURED_NEWS: (data) => {
    return {
      event: 'exit click',
      data: {
        exitLink: data.linkText,
        exitURL: data.linkUrl,
      },
    };
  },
  CAROUSEL_CTA_CLICKS: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.linkText,
        interactionValue: data.linkValue,
        interactionContext: data.linkContext,
      },
    };
  },
  API_TRANSACTION_ERROR: (data) => {
    return {
      event: 'siteError',
      data: {
        errorMessage: data.message,
        errorHttpsCode: data.status,
        errorApiCode: data.code,
        errorType: 'site',
        productName: data?.resourceId,
        taskId: data?.operationName,
        pageName: data?.pageName
          ? `${pageNamePrefix}${data?.pageName}`
          : `${pageNamePrefix}`,
      },
    };
  },
  ABYSS_FORM_SUBMIT_ERROR: (data) => {
    return {
      event: 'formError',
      data: {
        errorMessage: 'Missing or invalid field(s)',
        errorFields: Object.keys(data.fields || {}).join(','),
        errorType: 'form',
        pageName: data?.pageName
          ? `${pageNamePrefix}${data?.pageName}`
          : `${pageNamePrefix}`,
      },
    };
  },
  TRACKIT_LINK_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'trackIt flyout widget',
        interactionValue: data.tabName,
      },
    };
  },
  TRACKIT_MODAL_VIEW: (data) => {
    return {
      event: 'modal view',
      data: {
        modalName: 'trackit flyout',
      },
    };
  },
  TRACKIT_MODAL_CLOSE: (data) => {
    return {
      event: 'modal close',
      data: {
        modalName: 'trackit flyout',
      },
    };
  },
  PROFILE_SETTING_LINKS: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'profiles and settings',
        interactionValue: data.linkText,
      },
    };
  },
  PREFERRED_SEARCH_DX_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'search diagnosis code',
        interactionValue: data.searchTerm,
        interactionContext: preferredLab,
      },
    };
  },
  PREFERRED_SELECT_DX_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'select a diagnosis code',
        interactionValue: data.code,
        interactionContext: preferredLab,
      },
    };
  },
  PREFERRED_SEARCH_CPT_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'search procedure code',
        interactionValue: data.searchTerm,
        interactionContext: preferredLab,
      },
    };
  },
  PREFERRED_SELECT_CPT_CODE: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'select a procedure code',
        interactionValue: data.code,
        interactionContext: preferredLab,
      },
    };
  },
  PRINT_PAGE_CONTEXT: (data) => {
    return {
      event: 'print',
      data: {
        printContext: data.tabName,
      },
    };
  },
  TRAINING_TIP_VIEW: (data) => {
    return {
      event: 'training tip view',
      data: {
        trainingName: data.trainingName,
        trainingModalName: data.modalName,
      },
    };
  },

  TRAINING_TIP_CLOSE: (data) => {
    return {
      event: 'training tip close',
      data: {
        trainingName: data.trainingName,
        trainingModalName: data.modalName,
      },
    };
  },
  UHCPP_CUSTOMIZED_TAB_WIDGET_CLICKS: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'UHCPP Customized Tab Widget Clicks',
        interactionValue: data.tabName,
        interactionContext: data.tabContext,
      },
    };
  },
  REFERENCE_NUMBER_PRINT_OR_SAVE: (data) => {
    return {
      event: 'printOrSavePDFModalClicks',
      data: {
        referenceNo: data.refNum || '',
        generateReferenceNoFlag: data.refNumFlag || 'no',
        printOptionsSelected: data.printSections || '',
      },
    };
  },
  SMART_EDITS_AB: (data) => {
    return {
      event: 'smartEditActionRequiredABTest',
      data: {
        smartEditActionRequiredFlag: data.smartEditActionRequiredFlag,
        noOfSmartEditActionRequired: data.noOfSmartEditActionRequired,
      },
    };
  },
  PAAN_5_TAB_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Prior Authorizations & Notifications Tab Widget',
        interactionValue: 'Go to the Prior Authorization/Notifications tool',
        interactionContext: 'UHCPP Customized Tab Widget link clicks',
      },
    };
  },
  PAAN_5_TAB_LINK_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext:
          'Prior Authorization and Notification Tab Widget link clicks',
      },
    };
  },
  RIGHT_RAIL_LINK_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: data.widgetName
          ? `${data.widgetName} right rail nav link clicks`
          : 'right rail nav link clicks',
      },
    };
  },
  RIGHT_RAIL_SLIDE_NAVIGATION_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: 'right rail link clicks',
      },
    };
  },
  BUMPER_STICKER_AND_BILLBOARD_LINK_CLICKS: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: 'bumper sticker and billboard link clicks',
      },
    };
  },
  RIGHT_RAIL_MOBILE_WIDGET_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: 'right rail nav link clicks in mobile widget',
      },
    };
  },
  YOUR_FEATURED_NEWS_WIDGET_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Your Featured News',
        interactionValue: data.interactionValue,
        interactionContext: data.interactionContext,
      },
    };
  },

  PAAN_TASK_TAB_SELECTION: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Prior Authorizations & Notifications Tab Widget',
        interactionValue: data.interactionValue,
        interactionContext: 'UHCPP Customized Tab Widget link clicks',
      },
    };
  },
  PAAN_TASK_LINK_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext:
          'Prior Authorization and Notification Tab Widget link clicks',
      },
    };
  },
  MPP_ACTION_CLICKS: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'TrackIt Action Required Widget',
        interactionValue: data.textValue,
        interactionContext: data.appName,
      },
    };
  },
  DOCUMENT_LIBRARY_ACTION_CLICKS: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'TrackIt Action Required Widget',
        interactionValue: 'Assigned to You',
        interactionContext: data.appName,
      },
    };
  },
  ACCESS_REQUESTS_BAR_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Action Required',
        interactionValue: 'Access Requests Widget',
        interactionContext: data.interactionContext,
      },
    };
  },
  CONTACT_US_GET_STARTED_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Network help and support',
        interactionValue: 'Get Started',
        interactionContext: 'Contact us',
      },
    };
  },
  ACTION_REQUIRED_CHECK_BOX_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Trackit Action Required Widget',
        interactionValue: data.interactionValue,
        interactionContext: 'show only items that require action click',
      },
    };
  },
  ACTION_REQUIRED_ACTION_ITEMS_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: 'Trackit Action Required Widget',
        interactionValue: data.interactionValue,
        interactionContext: data.interactionContext,
      },
    };
  },
  OON_CONSENT_MODAL_OPEN: (data) => {
    return {
      event: 'modal view',
      data: {
        modalName: data.modalName,
      },
    };
  },
  OON_CONSENT_MODAL_CLOSE: (data) => {
    return {
      event: 'modal close',
      data: {
        modalName: data.modalName,
      },
    };
  },
  OON_CONSENT_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: data.interactionContext,
      },
    };
  },
  OON_CONSENT_START: (data) => {
    return {
      event: 'jobStart',
      data: {
        jobName: data.jobName,
      },
    };
  },
  OON_CONSENT_OPT_OUT_OPEN: (data) => {
    return {
      event: 'modal view',
      data: {
        modalName: data.modalName,
      },
    };
  },
  OON_CONSENT_OPT_OUT_CONFIRMATION: (data) => {
    return {
      event: 'modal close',
      data: {
        modalName: data.modalName,
      },
    };
  },
  OON_CONSENT_OPT_OUT_COMPLETION: (data) => {
    return {
      event: 'jobComplete',
      data: {
        jobName: data.jobName,
      },
    };
  },
  OON_CONSENT_OPT_OUT_CANCELLATION: (data) => {
    return {
      event: 'jobCancel',
      data: {
        jobName: data.jobName,
      },
    };
  },
  IDLE_MODAL_OPEN: (data) => {
    return {
      event: 'modal view',
      data: {
        modalName: data.modalName,
      },
    };
  },
  IDLE_MODAL_CLOSE: (data) => {
    return {
      event: 'modal close',
      data: {
        modalName: data.modalName,
      },
    };
  },
  IDLE_MODAL_CLICK: (data) => {
    return {
      event: 'interaction',
      data: {
        interactionName: data.interactionName,
        interactionValue: data.interactionValue,
        interactionContext: data.interactionContext,
      },
    };
  },
};
